import { dataHooks } from '@wix/data-hooks'

export const wixMobileBaseCheckboxDataHooks = dataHooks<{
  item: { key: string }
  itemCheckbox: { key: string }
  back: {}
  skip: {}
  next: {}
  stepProgressBar: {}
  title: {}
  subtitle: {}
}>('wix-mobile-base-checkbox')
